import { el, list, setChildren, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import boldToggleIconString from 'assets/images/bold-formatting-toggle-icon.svg?raw';
import italicToggleIconString from 'assets/images/italic-formatting-toggle-icon.svg?raw';
import underlineToggleIconString from 'assets/images/underline-formatting-toggle-icon.svg?raw';
import strikeThroughToggleIconString from 'assets/images/strike-through-toggle-icon.svg?raw';

import bulletListToggleIconString from 'assets/images/bullet-list-toggle-icon.svg?raw';
import numberedListToggleIconString from 'assets/images/number-list-toggle-icon.svg?raw';
import checkListToggleIconString from 'assets/images/check-list-toggle-icon.svg?raw';

import h1ToggleIconString from 'assets/images/h1-toggle-icon.svg?raw';
import h2ToggleIconString from 'assets/images/h2-toggle-icon.svg?raw';
import h3ToggleIconString from 'assets/images/h3-toggle-icon.svg?raw';
import h4ToggleIconString from 'assets/images/h4-toggle-icon.svg?raw';
import h5ToggleIconString from 'assets/images/h5-toggle-icon.svg?raw';

import leftAlignmentToggleIconString from 'assets/images/left-alignment-toggle-icon.svg?raw';
import rightAlignmentToggleIconString from 'assets/images/right-alignment-toggle-icon.svg?raw';
import centerAlignmentToggleIconString from 'assets/images/center-alignment-toggle-icon.svg?raw';

import actionTypes from '../../action-types';

import {
  setIconClasses
} from '../utilities';

import './index.scss';

const boldToggleIcon = stringToSVG(boldToggleIconString);
const italicToggleIcon = stringToSVG(italicToggleIconString);
const underlineToggleIcon = stringToSVG(underlineToggleIconString);
const strikeThroughToggleIcon = stringToSVG(strikeThroughToggleIconString);
const bulletListToggleIcon = stringToSVG(bulletListToggleIconString);
const numberedListToggleIcon = stringToSVG(numberedListToggleIconString);
const checkListToggleIcon = stringToSVG(checkListToggleIconString);
const h1ToggleIcon = stringToSVG(h1ToggleIconString);
const h2ToggleIcon = stringToSVG(h2ToggleIconString);
const h3ToggleIcon = stringToSVG(h3ToggleIconString);
const h4ToggleIcon = stringToSVG(h4ToggleIconString);
const h5ToggleIcon = stringToSVG(h5ToggleIconString);
const leftAlignmentToggleIcon = stringToSVG(leftAlignmentToggleIconString);
const rightAlignmentToggleIcon = stringToSVG(rightAlignmentToggleIconString);
const centerAlignmentToggleIcon = stringToSVG(centerAlignmentToggleIconString);

setIconClasses('text-mark-icon', boldToggleIcon, italicToggleIcon, underlineToggleIcon, strikeThroughToggleIcon);
setIconClasses('heading-icon', h1ToggleIcon, h2ToggleIcon, h3ToggleIcon, h4ToggleIcon, h5ToggleIcon);
setIconClasses('alignment-icon', leftAlignmentToggleIcon, rightAlignmentToggleIcon, centerAlignmentToggleIcon);

export class MarkButton {

  constructor(markButtons) {

    this.markButtons = markButtons;
    this.mark = null;

    this.button = el('button.inline-toolbar-button', { onmousedown: this.onClick.bind(this) });
    this.el = el('x-tooltip', this.button);

  }

  onClick() {

    this.mark.active = !this.mark.active;
    this.markButtons.onClick(this.mark.type);
    this.update(this.mark);

  }

  update(mark) {

    this.mark = mark;

    const type = this.mark.type;

    let icon = null;

    if (type === actionTypes.BOLD) {
      icon = boldToggleIcon.cloneNode(true);
    } else if (type === actionTypes.ITALIC) {
      icon = italicToggleIcon.cloneNode(true);
    } else if (type === actionTypes.UNDERLINE) {
      icon = underlineToggleIcon.cloneNode(true);
    } else if (type === actionTypes.STRIKE_THROUGH) {
      icon = strikeThroughToggleIcon.cloneNode(true);
    } else if (type === actionTypes.BULLET_LIST) {
      icon = bulletListToggleIcon.cloneNode(true);
    } else if (type === actionTypes.NUMBER_LIST) {
      icon = numberedListToggleIcon.cloneNode(true);
    } else if (type === actionTypes.CHECK_LIST) {
      icon = checkListToggleIcon.cloneNode(true);
    } else if (type === actionTypes.HEADING_ONE) {
      icon = h1ToggleIcon.cloneNode(true);
    } else if (type === actionTypes.HEADING_TWO) {
      icon = h2ToggleIcon.cloneNode(true);
    } else if (type === actionTypes.HEADING_THREE) {
      icon = h3ToggleIcon.cloneNode(true);
    } else if (type === actionTypes.HEADING_FOUR) {
      icon = h4ToggleIcon.cloneNode(true);
    } else if (type === actionTypes.HEADING_FIVE) {
      icon = h5ToggleIcon.cloneNode(true);
    } else if (type === actionTypes.ALIGN_LEFT) {
      icon = leftAlignmentToggleIcon.cloneNode(true);
    } else if (type === actionTypes.ALIGN_CENTER) {
      icon = centerAlignmentToggleIcon.cloneNode(true);
    } else if (type === actionTypes.ALIGN_RIGHT) {
      icon = rightAlignmentToggleIcon.cloneNode(true);
    }

    setChildren(this.button, [icon]);

    if (this.mark.active === true) {
      this.button.classList.add('active');
    } else {
      this.button.classList.remove('active');
    }

    setAttr(this.el, {
      text: this.mark.tooltip
    });
  }

}

class MarkButtons {

  constructor(configuration) {

    this.container = configuration.container;
    this.marks = configuration.marks;
    this.onClick = configuration.onClick;

    this.buttons = list('.mark-buttons.toolbar-buttons-container', MarkButton, null, this);
    this.buttons.update(this.marks);

    this.el = el('.mark-buttons-container-main', {
      onmouseenter: this.container.show.bind(this.container),
      onmouseleave: this.container.tryHide.bind(this.container)
    }, [this.buttons]);

  }

  hide() {

    this.el.classList.remove('active');

  }

  show() {

    this.el.classList.add('active');

    return new Promise(function resolver(resolve) {
      setTimeout(resolve, 200);
    });

  }

  update(configuration) {

    this.marks = configuration.marks;
    this.onClick = configuration.onClick;

    this.buttons.update(this.marks);

  }

}

export class ToolContainer {

  constructor(configuration) {

    this.anchor = configuration.anchor;
    this.buttons = configuration.buttons;

    this.el = el('.mark-buttons-container-main', {
      onmouseenter: this.anchor.show.bind(this.anchor),
      onmouseleave: this.anchor.tryHide.bind(this.anchor)
    }, [this.buttons]);

  }

  hide() {

    this.el.classList.remove('active');

  }

  show() {

    this.el.classList.add('active');

  }

  update(configuration) {

    this.marks = configuration.marks;
    this.onClick = configuration.onClick;

    this.buttons.update(this.marks);

  }

}

export default MarkButtons;